// See screen-width-breakpoints.less
export const ULTRAMOBILE = 430;
export const MOBILE = 751;
export const TABLET = 1039;
export const DESKTOP = 1327;
export const WIDESCREEN = 1615;

export const isScreenUltraMobile = () => window.innerWidth <= ULTRAMOBILE;
export const isScreenMobile = () => window.innerWidth > ULTRAMOBILE && window.innerWidth <= MOBILE;
export const isScreenTablet = () => window.innerWidth > MOBILE && window.innerWidth <= TABLET;
export const isScreenDesktop = () => window.innerWidth > TABLET && window.innerWidth <= DESKTOP;
export const isScreenWidescreen = () => window.innerWidth > DESKTOP && window.innerWidth <= WIDESCREEN;
export const isScreenUltrawide = () => window.innerWidth > WIDESCREEN;
